"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Request = require("./_request-api");
var Platform = require("./platform");
var constants_1 = require("../data/constants");
var getUploadUrl = function (platform, file, path) {
    var fullPath = [
        "platforms",
        platform.id,
        path,
    ].filter(function (e) { return e; }).join("/");
    return Request.sendPost(constants_1.endpoints.upload, {
        path: fullPath,
        file_name: file ? parameterize(file.name) : null,
        file_type: file ? encodeURIComponent(file.type) : null,
    });
};
var uploadToUrl = function (data, file) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('PUT', data['signed_request']);
        xhr.onreadystatechange = function () {
            if (xhr.readyState !== 4) {
                return;
            }
            if (xhr.status !== 200) {
                reject();
            }
            resolve({
                url: data['url'],
                name: file.name,
                type: file.type,
            });
        };
        xhr.send(file);
    });
};
var resize = function (path) {
    return Request.sendPost(constants_1.endpoints.upload + "/resize", {
        key: path,
    });
};
var parameterize = function (value) {
    var transformation = value.toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
    return encodeURIComponent(transformation);
};
var upload = function (file, path) {
    return Platform.current()
        .then(function (platform) {
        return getUploadUrl(platform, file, path)
            .then(function (data) { return uploadToUrl(data, file); })
            .then(function (data) { return resize(data.url); });
    });
};
exports.upload = upload;
//# sourceMappingURL=upload.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/upload.js
// module id = 913
// module chunks = 3